import React, { useState } from 'react';
import axios from 'axios';
import './ForgotPassPage.css';

const ForgotPassPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/password/forgot', { email });
            if (response.data.exists) {
                setMessage('A reset link has been sent to your email.');
            } else {
                setMessage('Email does not exist.');
            }
        } catch (error) {
            setMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className="forgot-pass-page">
            <h2>Forgot Password</h2>
            <form className='submit-email-form' onSubmit={handleSubmit}>
                <label htmlFor="email">Email:</label>
                <input
                    className='email-input'
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button href="/api/password/forgot" className='submit-email-btn'>Verify Email</button>
            </form>
            {message && <p>{message}</p>}
        </div>
    );
};

export default ForgotPassPage;